var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"i-layout-header-logo i-layout-header-logo-stick",staticStyle:{"height":"48px","line-height":"48px","width":"240px"},attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/images/logo.jpg"}}),_c('b',{staticStyle:{"color":"#515a6e"}},[_vm._v("邯郸市农业综合行政执法支队")])])
}]

export { render, staticRenderFns }